module.exports = __webpack_public_path__ + "img/echope_small.c87946e3.png";